import { IBooking } from '../../models/IBooking';
import { getIsFutureBooking } from './getIsFutureBooking';

export function getIsCancelAllowed(booking: IBooking) {
	return getIsFutureBooking(booking) && booking.status !== 'canceled';
}
